import React, { Suspense } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { MainArticleLayout } from '../../layouts/MainArticleLayout'
import ErrorFallback from '../common/ErrorFallback'
import WorkplaceBasicsBreadcrumbs from './WorkplaceBasicsBreadcrumbs'
import WorkplaceBasicsView from './WorkplaceBasicsView'

const WorkplaceBasicsLanding = () => {
  return (
    <Suspense fallback={null}>
      <MainArticleLayout>
        <WorkplaceBasicsBreadcrumbs />
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <WorkplaceBasicsView />
          <p></p>
        </ErrorBoundary>
      </MainArticleLayout>
    </Suspense>
  )
}

export default WorkplaceBasicsLanding
